<template>
  <div>
    <app-header title="Settings" />

    <div class="container container-fluid mt-4 mb-4">
      <ul class="nav nav-grid">
        <li v-if="$isA('admin')" class="nav-item col-12 col-sm-6 col-md-4 col-xl-3">
          <router-link class="nav-link" :to="{ name: 'settings.screen-tags' }">
            <i class="far fa-tags"></i>
            <div>
              Screen Tags
              <span class="description">Tags to group screens together.</span>
            </div>
          </router-link>
        </li>
        <li v-if="$isA('admin')" class="nav-item col-12 col-sm-6 col-md-4 col-xl-3">
          <router-link class="nav-link" :to="{ name: 'settings.media-owner-tags' }">
            <i class="far fa-tags"></i>
            <div>
              Media Owner Tags
              <span class="description">Tags to group media owners together.</span>
            </div>
          </router-link>
        </li>
        <li v-if="!$isA('admin')" class="nav-item col-12 col-sm-6 col-md-4 col-xl-3">
          <router-link class="nav-link" :to="{ name: 'settings.media-owner-screen-tags' }">
            <i class="far fa-tags"></i>
            <div>
              Media Owner Screen Tags
              <span class="description">Tags used by media owners to group screens together.</span>
            </div>
          </router-link>
        </li>
        <li v-if="$isA('admin')" class="nav-item col-12 col-sm-6 col-md-4 col-xl-3">
          <router-link class="nav-link" :to="{ name: 'settings.integrations' }">
            <i class="far fa-link"></i>
            <div>
              Integrations
              <span class="description">Create and manage integrations with third party systems.</span>
            </div>
          </router-link>
          </li>
        <li v-if="$isA('admin')" class="nav-item col-12 col-sm-6 col-md-4 col-xl-3">
          <router-link class="nav-link" :to="{ name: 'settings.data-transfer' }">
            <i class="far fa-random"></i>
            <div>
              Data Transfer
              <span class="description">Transfer historical data from an existing screen to a new screen.
              </span>
            </div>
          </router-link>
        </li>
        <li v-if="$can('read settings')" class="nav-item col-12 col-sm-6 col-md-4 col-xl-3">
          <router-link class="nav-link" :to="{ name: 'settings.report-configuration' }">
            <i class="far fa-cog"></i>
            <div>
              Report Configuration
              <span class="description">Create and manage rules for system reports.</span>
            </div>
          </router-link>
        </li>
        <li v-if="$isA('admin') && $can('read settings')" class="nav-item col-12 col-sm-6 col-md-4 col-xl-3">
          <router-link class="nav-link" :to="{ name: 'settings.energy-providers' }">
            <i class="far fa-bolt"></i>
            <div>
              Energy Providers
              <span class="description">
                Manage the list of energy providers and their associated outage page links.
              </span>
            </div>
          </router-link>
        </li>
        <li v-if="$isA('admin')" class="nav-item col-12 col-sm-6 col-md-4 col-xl-3">
          <router-link class="nav-link" :to="{ name: 'settings.rail-app-release' }">
            <i class="far fa-random"></i>
            <div>
              Rail Application Version History and Change Log
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
}
</script>
